import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { FadeIn } from "./Reveal";

const CTASection = ({ title = "Legacy Applications. Modern Possibilities.", sub }) => (
  <section data-testid="cta-section" className="relative border-t hairline bg-ink-light overflow-hidden">
    <div className="absolute -top-32 left-1/4 w-[500px] h-[500px] rounded-full bg-amber-600/10 blur-3xl pointer-events-none" />
    <div className="relative mx-auto max-w-[1400px] px-6 md:px-12 py-24 md:py-36">
      <FadeIn>
        <p className="label-mono mb-6">Begin the conversation</p>
        <h2 className="font-serif text-4xl md:text-6xl text-slate-100 tracking-tight leading-none max-w-3xl">
          {title}
        </h2>
        {sub && (
          <p className="mt-6 text-slate-400 text-lg font-light leading-relaxed max-w-xl">{sub}</p>
        )}
        <div className="mt-10 flex flex-wrap gap-5">
          <Link
            to="/contact"
            data-testid="cta-primary-button"
            className="group inline-flex items-center gap-3 bg-amber-400 text-ink px-8 py-4 font-mono-tech text-xs tracking-[0.22em] uppercase transition-[background-color] duration-300 hover:bg-amber-300"
          >
            Request an Assessment
            <ArrowUpRight size={16} className="transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" />
          </Link>
          <Link
            to="/approach"
            data-testid="cta-secondary-button"
            className="inline-flex items-center gap-3 border border-amber-700/50 px-8 py-4 font-mono-tech text-xs tracking-[0.22em] uppercase text-amber-400 transition-[background-color,color] duration-300 hover:bg-amber-500/10"
          >
            See How We Work
          </Link>
        </div>
      </FadeIn>
    </div>
  </section>
);

export default CTASection;
